import React, {useContext} from 'react';
import {SellFactorSCLContext} from "../SellFactorContext";

function FactorTypeSellScl(props) {
  const helper = useContext(SellFactorSCLContext);
  const setData = helper.setData
  const data = helper.data

  try {
    return (<div>

      <div className={'divgroup'}>
        <label htmlFor="paymentType">نحوه پرداخت</label>
        <select
          id="paymentType"
          className={"w-100 px-3 form-select"}
          onChange={e => {
            const value = e.target.value
            setData({sendData: {...data.sendData, factorType: value}})
          }}
          value={data.sendData.factorType}
        >
          <option value="preFactor">پیش فاکتور</option>
          <option value="factor">فاکتور</option>
        </select>
      </div>

    </div>);
  } catch (error) {
    return <>{error.toString()}</>
  }
}

export default FactorTypeSellScl;